






















import Vue from 'vue';
import Component from 'vue-class-component';

const TextInputProps = Vue.extend({
  props: {
    label: String,
    type: String,
    rules: Array,
    prefix: String,
    suffix: String,
    appendIcon: String,
    prependIcon: String,
    value: [String, Number],
    unavailable: Boolean,
    readonly: Boolean,
  },
});

@Component
export default class TextInput extends TextInputProps {
  onchange(data: any) {
    this.$emit('input', data);
  }
}
